import { ApplianceModel } from '@common/models';

import { staticContentService } from '../staticContentService';

const faucetApi = staticContentService.injectEndpoints({
    endpoints: (builder) => ({
        fetchInStoreFaucets: builder.query<ApplianceModel[], { url: string }>({
            query: ({ url }) => ({
                url,
                method: 'GET',
            }),
        }),
    }),
});

export const { useFetchInStoreFaucetsQuery, useLazyFetchInStoreFaucetsQuery } = faucetApi;
